export default "__VITE_ASSET__DCJPeGw7__"